import React, { useState } from "react";
import { Button, Paper } from "@mui/material";
import { createUseStyles } from "react-jss";
import { useAuth0 } from "@auth0/auth0-react";
import { Layout, Popin, Table, Text } from "$components";
import { checkAPI, checkProtectedApi } from "$api/api";
import constants from "$utils/constants";

function Main() {
  const classes = useStyles();
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [message, setMessage] = useState("");
  const [openPopin, setOpenPopin] = React.useState(false);

  const toggleDrawer = (open: boolean) => {
    setOpenPopin(open);
  };

  const handleCheckApi = async () => {
    const data = await checkAPI();
    setMessage((data as any)?.message);
  };

  const handleCheckSecuredApi = async () => {
    const token = await getAccessTokenSilently();
    const data = await checkProtectedApi(token);

    setMessage((data as any)?.message);
  };

  const handleCheckProtectedApi = async () => {
    const token = await getAccessTokenSilently();
    const data = await checkProtectedApi(
      token,
      constants.API.ENDPOINTS.PROTECTED
    );

    setMessage((data as any)?.message);
  };

  /* static data table */
  const columns = [
    { id: "name", label: "Name", minWidth: 170 },
    { id: "email", label: "ISO\u00a0Code", minWidth: 100 },
    {
      id: "population",
      label: "Population",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toLocaleString("en-US"),
    },
    {
      id: "size",
      label: "Size\u00a0(km\u00b2)",
      minWidth: 170,
      align: "right",
      format: (value: number) => value.toLocaleString("en-US"),
    },
  ];

  const rows = [
    [
      {
        value: "India",
        type: "link",
        link: "/test",
      },
      {
        value: "IN",
        color: "red",
      },
      {
        value: 1324171354,
        color: "green",
      },
      {
        value: 458,
      },
    ],
    [
      {
        value: "Austria",
        isDisable: true,
        color: "red",
      },
      {
        value: "AU",
        isDisable: true,
      },
      {
        value: 1324171354,
        isDisable: true,
      },
      {
        value: 458,
        isDisable: true,
      },
    ],
    [
      {
        value: "Austria",
        color: "green",
      },
      {
        value: "AU",
      },
      {
        value: 1324171354,
      },
      {
        value: 458,
      },
    ],
  ];
  /* static data table */

  return (
    <Layout contentClassName={classes.content}>
      <div className={classes.dataContainer}>
        <Text>test</Text>
        <Table rowsPerPage={2} thead={columns} bodyData={rows} />
      </div>
      <Button
        color="primary"
        variant="contained"
        onClick={() => toggleDrawer(true)}
      >
        Open popin
      </Button>
      <Popin openPopin={openPopin} toggleDrawer={toggleDrawer}>
        <p>test</p>
      </Popin>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={() => handleCheckApi()}
      >
        Check Api
      </Button>
      {isAuthenticated && (
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => handleCheckSecuredApi()}
        >
          Check Connected Client Api
        </Button>
      )}
      {isAuthenticated && (
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => handleCheckProtectedApi()}
        >
          Check Connected Admin Api
        </Button>
      )}

      <Paper elevation={3}>Message : {message}</Paper>
      <Popin openPopin={openPopin} toggleDrawer={toggleDrawer}>
        <p>test</p>
      </Popin>
    </Layout>
  );
}

const useStyles = createUseStyles(() => ({
  content: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  dataContainer: {
    background: "#fff",
    width: "100%",
    borderRadius: 5,
  },
  button: {
    marginTop: "5px !important",
    marginBottom: "5px !important",
  },
}));

export default Main;
